exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-tool-type=\"richText\"] ol li{list-style:decimal}[data-tool-type=\"richText\"] ul li{list-style:initial}\n", ""]);

